import styled from 'styled-components'
import {Link} from 'react-router-dom'

export const Li = styled(Link)`
  text-decoration: none;
  font-weight: 500;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  padding: 13px 0px 13px 22px;
  background-color: ${props => {
    if (props.active === 'hightLight') {
      return props.dark ? '#616e7c' : '#e2e8f0'
    }
    return ''
  }};
`

export const SideContianer = styled.div`
  display: flex;
  background-color: ${props => (props.dark ? '#212121' : 'white')};

  @media (max-width: 768px){
    display: none;
  }
`

export const SideCard = styled.div`
  background-color: ${props => (props.dark ? '#212121' : 'white')};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 92vh;
  width: 20vw;
  position: sticky;
  top: 60px;
`

export const Top = styled.div`
  padding: 20px 0px;
`

export const Ul = styled.ul`
  display: grid;
  padding: 0px;
`

// export const Li = styled.li`
//   list-style-type: none;
//   color: ${props => (props.dark ? '#cccccc' : '#475569')};
//   padding: 13px 0px 13px 25px;
//   display: flex;
//   align-items: center;
//   flex: 1;
//   gap: 15px;
// `

export const List = styled.p`
  color: ${props => (props.dark ? '#ffffff' : '#212121')};
  font-size: 15px;
`

export const Bottom = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin: 20px;
`

export const SidebarP = styled.p`
  color: ${props => (props.dark ? 'white' : '#212121')};
  font-size: ${props => (props.contact ? '16px' : '14px')};
  font-weight: bold;
`

export const ContactIcons = styled.div`
  display: flex;
  align-items: center;
  gap: 13px;
`

export const ContactIcon = styled.img`
  width: 30px;
`

export const Button = styled.button`
  border: none;
  ouline: none;
  cursor: pointer;
  background: transparent;
  padding: 0px;
`
